var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('keep-alive',{attrs:{"include":_vm.tabNames,"exclude":_vm.excludeTabs}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }